<template>
  <div class="watcher-count">
    <div style="display: flex; flex: 1; align-items: center">{{watcherCount}}</div>
  </div>
</template>

<script>
export default {
  name: "WatcherCount",
  props: ["watcherCount"],
};
</script>



// WEBPACK FOOTER //
// src/components/WatcherCount.vue